/*

 // meta: emitter identifier, e.g., `wm` for `Widget Manager`, `w1:1` for `Widget-1:Instance-1` (`id`)
  // payload: any number of optional params

  SL.wm.eb.on('greeting', (meta, payload) => {
    console.log(`Hello ${payload}!`);
  });

  SL.wm.eb.emit('greeting', 'w1:1', 'John Doe');
 */

import * as shared from './shared';

const win = window as any;

interface ISL {
	wm: {
		eb: shared.ISlEventBus;
	};
}

(window as any).SL = (window as any).SL || {};
(window as any).SL.evo = (window as any).SL.evo || {};
(window as any).SL.evo.ebIsReady = false;
(window as any).SL.evo.ebReadyList = [];
(window as any).SL.evo.ebReady = () => {
	(window as any).SL.evo.ebIsReady = true;
	(window as any).SL.evo.ebReadyList.forEach((resolve: (eb: shared.ISlEventBus) => void) => {
		resolve((window as any).SL.wm.eb);
	});
};

const eventBus = (): Promise<shared.ISlEventBus> => {
	return new Promise((resolve) => {
		if ((window as any).SL.evo.ebIsReady) {
			resolve((window as any).SL.wm.eb);
			return;
		}
		// if eventBus is not yet ready store resolve function in array
		(window as any).SL.evo.ebReadyList.push(resolve);
	});
};
export * from './shared';
export default eventBus;
